module.exports = __webpack_public_path__ + "static/media/success.f5bc0d0b.png";